import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _ProcessPropertiesItem } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    hasError?: boolean;
    selectFirst?: boolean;
}

export const SelectProcessTypeConstants = ({ idSelector, onChange, label, required, disabled, hasError, selectFirst }: Props) => {

    const { instance } = useDataBean(_ProcessPropertiesItem);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<number>(idSelector ?? 0);

    useEffect(() => {
        getProcessTypeConstants();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector ?? 0);
        }
    }, [idSelector]);

    const getProcessTypeConstants = () => {
        instance.getProcessTypeConstants(null).then(
            (resp: any) => {
                const list = Array.isArray(resp) ? resp : [];
                setLista(list);

                if (selectFirst && !idSelector && list.length > 0) {
                    const value = Number(list[0].DataBeanProperties.Value);
                    setValue(value);
                }
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const setValue = (value: number) => {
        setID(value);
        onChange(value);
    };

    return (
        <>
            <label className={hasError ? "has-error" : ""}>
                {label ?? "Tipo de Proceso"} {required ? <span className="text-danger">*</span> : ""}
            </label>
            <select
                disabled={disabled}
                className="form-select"
                value={id}
                onChange={(e) => { setValue(Number(e.target.value)); }}
            >
                <option value={0}>...</option>
                {lista.map((item: any, index: number) => (
                    <option key={index} value={item.DataBeanProperties.Value}>
                        {item.DataBeanProperties.Property}
                    </option>
                ))}
            </select>
        </>
    );
};
